(function() {
    window.c24.lp.ac.addQTip = function(settings) {

        if (!settings.acType || !settings.hoverElement || !settings.toolTipChild) {
            return;
        }

        let elements;

        if (settings.hoverElementContext) {
            elements = $('.mod24ac.' + settings.acType + ' ' + settings.hoverElement, settings.hoverElementContext);
        } else {
            elements = $('.mod24ac.' + settings.acType + ' ' + settings.hoverElement);
        }

        $.each(elements, function(_, el) {
            const tooltipText = $(settings.toolTipChild, el).html();

            if (!settings.arrowPosition || !settings.parentPosition) {
                const $el = $(el);
                const ac = $el.closest('.mod24ac');

                if ($el.offset().left + ($el.width() / 2) > ac.offset().left + (ac.width() / 2)) {
                    settings.arrowPosition = settings.arrowPosition || 'right center';
                    settings.parentPosition = settings.parentPosition || 'left center';

                } else {
                    settings.arrowPosition = settings.arrowPosition || 'left center';
                    settings.parentPosition = settings.parentPosition || 'right center';
                }
            }

            let adjustMethod;
            if (typeof settings.adjust === 'string') {
                adjustMethod = settings.adjust;
            } else {
                adjustMethod = settings.adjust ? 'shift flip' : 'none none';
            }

            $(el).qtip({
                content: {
                    text: tooltipText,
                    button: (window.c24LpNotPinnedQtip ? null : 'Schließen'),
                },
                style: {
                    classes: 'c24Editor' + (window.c24LpNotPinnedQtip ? '' : ' closable') + (settings.classes ? ' ' + settings.classes : ''),
                    tip: {
                        border: 1,
                        width: 16,
                        height: 9,
                    },
                },
                show: {
                    event: (window.c24LpNotPinnedQtip ? 'mouseenter' : 'click focus'),
                },
                hide: {
                    event: (window.c24LpNotPinnedQtip ? 'mouseleave focusout' : ''),
                    fixed: true,
                    delay: (settings.hideDelay !== undefined ? settings.hideDelay : 500),
                },
                position: {
                    viewport: (settings.viewport ? settings.viewport : $('html')) ,
                    // Position of the arrow
                    my: settings.arrowPosition,
                    // Position relative to the parent element
                    at: settings.parentPosition,
                    adjust: {
                        method: adjustMethod,
                    },
                },
                events: {
                    render: function(event, api) {
                        window.c24OnRenderQtip(event, api);
                    },

                    move: function(event, api, position) {
                        window.c24RepositionQTip(api, position);
                    },
                },
            });
        });
    };

    window.c24.lp.ac.addDefaultQtips = function(acType) {
        window.c24.lp.ac.addQTip({
            acType: acType,
            adjust: 'flipinvert',
            hoverElement: '.siegel > div',
            toolTipChild: '.js24Tooltip',
            hideDelay: 500,
        });
        window.c24.lp.ac.addQTip({
            acType: acType,
            hoverElement: '.box24Teaser',
            toolTipChild: '.js24Tooltip',
            hideDelay: 500,
        });
        window.c24.lp.ac.addQTip({
            acType: acType,
            adjust: true,
            hoverElement: '.footmarker',
            toolTipChild: '.js24Tooltip',
            arrowPosition: 'top center',
            parentPosition: 'bottom center',
            hideDelay: 500,
        });
        window.c24.lp.ac.addQTip({
            acType: acType,
            adjust: true,
            hoverElement: '.signet',
            toolTipChild: '.js24Tooltip',
            arrowPosition: 'right center',
            parentPosition: 'left center',
        });
    };
})();
